<script>
  import ChevronRight from './icons/svg/chevron-right.svelte';

  export let text = '';
  export let href = '';

  const nav = () => window.location.href = href;
</script>

<div class='bar'>
  <div class='part'>
    <div class='icon'>
      <ChevronRight/>
    </div>
    <h2 on:click={nav}>{text}</h2>
  </div>
</div>

<style>
  .icon {
    color: yellow;
  }
  .bar {
    display: flex;
    align-items: center;
  }
  .part {
    display: flex;
    align-items: center;
  }
  h2 {
    margin: 0;
    margin-top: -3px;
    font-size: 1.4rem;
    cursor: pointer;
    transition: all 100ms ease-in-out;
  }
  h2:hover {
    color: #ff3f99;
  }
</style>
